import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77a3b5af")

_pushScopeId("data-v-77a3b5af")
const _hoisted_1 = {
  key: 0,
  class: "errMsg"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, " Внимание нет данных! "))
    : _createCommentVNode("", true)
})